import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Popup', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    attrs: {
      "width": "100%",
      "position": "right",
      "show-mask": false
    },
    model: {
      value: _vm.currValue,
      callback: function ($$v) {
        _vm.currValue = $$v;
      },
      expression: "currValue"
    }
  }, [_c('div', {
    staticClass: "write-execute"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('canvas', {
    ref: "signature-pad",
    staticClass: "signature-pad",
    attrs: {
      "id": "signature-pad"
    }
  })]), _c('div', {
    staticClass: "right-column"
  }, [_c('div', {
    staticClass: "item-text"
  }, [_c('span', {
    staticClass: "font-size-h3-large"
  }, [_vm._v(i18n.tc("532"))])]), _c('div', {
    staticClass: "item-close",
    on: {
      "click": function ($event) {
        _vm.currValue = false;
      }
    }
  }, [_c('span', {
    staticClass: "font-size-h3-large"
  }, [_vm._v(i18n.tc("533"))])]), _c('div', {
    staticClass: "item-clear",
    on: {
      "click": _vm.clear
    }
  }, [_c('span', {
    staticClass: "font-size-h3-large"
  }, [_vm._v(i18n.tc("534"))])]), _c('div', {
    staticClass: "item-confirm",
    on: {
      "click": _vm.submit
    }
  }, [_c('span', {
    staticClass: "font-size-h3-large"
  }, [_vm._v(i18n.tc("535"))])])])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };